import React from "react";
import Navbar from "../../components/navbar/Navbar";
import ShowDisplay from "./show-display/ShowDisplay";

const Shows = () => {
  return (
    <div>
      <Navbar />
      <ShowDisplay />
    </div>
  );
};
export default Shows;
